// Extending From
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LoginRoute extends Route {
  @service
  router;

  // login is handled in the application route. The only reason this exists is
  // so if someone has /login bookmarked it won't break.

  beforeModel() {
    // If this is running it means we have already authenticated the app but
    // some idiot pasted a callback url into their browser after already logging
    // in. Just transition to home.
    this.router.transitionTo('home');
  }
}
